//#region imports
import React from 'react';
import { useDispatch } from 'react-redux';
import FlightRowProps from '_scenes/portal/timeline-v2/job-components/flight-row-props';
import { EmployeeInformationColumnWidth } from '_scenes/portal/timeline-v2/timeline-constants';
import { setSelectedFlightToView } from '_redux/slices/timeline/selected-task';
import { setFlightModal } from '_redux/slices/timeline/timeline-control';
import { getPassengerFlightList } from '_redux/slices/timeline/flight-information-list';
import { Colors, Spacing } from '_styles';
import { IoEyeOutline } from 'react-icons/io5';
//#endregion

/**
 * FlightSearchRow - Wrapper component for displaying a flight row in search results
 * @param {Object} flight - The flight data object
 * @param {Function} onClick - Click handler for the flight row
 */
const FlightSearchRow = ({ flight, onClick }) => {
    const dispatch = useDispatch();

    const handleViewFlight = (e) => {
        e.stopPropagation(); // Prevent triggering the row onClick

        const type = flight?.type === 'arrival' ? 'inbound' : 'outbound';
        
        // Normalize origin/destination (search API uses departureAirport/arrivalAirport)
        const origin = flight?.origin || flight?.departureAirport;
        const destination = flight?.destination || flight?.arrivalAirport;
        const flightDate = flight?.flightDate || flight?.date;
        
        const iata = type === 'inbound' ? destination : origin;

        // Construct bookingKey if not present (format: flightNumber_origin_destination_date)
        const bookingKey = flight?.bookingKey || `${flight?.flightNumber}_${origin}_${destination}_${flightDate}`;

        // Create normalized flight object with all required fields
        const normalizedFlight = {
            ...flight,
            bookingKey,
            origin,
            destination,
            flightDate,
            // Also set operationTime if not present (for ViewFlight display)
            operationTime: flight?.operationTime || flight?.operationInfo?.time || flight?.scheduled,
        };

        /*
        dispatch(getPassengerFlightList({
            flightNumber: flight?.flightNumber,
            departureDate: flightDate,
            iata,
            type
        }));
        */
       
        dispatch(setSelectedFlightToView(normalizedFlight));
        dispatch(setFlightModal(true));
    };

    return (
        <div style={{
            minWidth: EmployeeInformationColumnWidth,
            maxWidth: EmployeeInformationColumnWidth,
        }}>
            <FlightRowProps 
                flight={flight} 
                onClick={onClick} 
            />
            <button
                onClick={handleViewFlight}
                style={{
                    width: '100%',
                    padding: Spacing.SCALE_6,
                    backgroundColor: flight?.type === 'arrival' ? Colors.LIGHT_GREEN : Colors.PRM_LIGHT_BLUE,
                    color: 'white',
                    border: 'none',
                    borderRadius: 4,
                    cursor: 'pointer',
                    fontSize: 12,
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: Spacing.SCALE_4,
                }}
            >
                <IoEyeOutline size={14} />
                View Flight
            </button>
        </div>
    );
};

export default FlightSearchRow;
